module.exports = __webpack_public_path__ + "static/img/you.f9eefcca.png";